export default {
      id: "my-patients-usage",
      viewBox: "0 0 32 29.912",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#my-patients",
      toString: function () {
        return this.url;
      }
    }